export const getDocumentUploadPath = (documentId: unknown): string => {
  const parsedDocumentId = Number(documentId);

  if (parsedDocumentId === 3 || parsedDocumentId === 6) {
    return "/applicant/applicant/upload-income-banking";
  }

  return "/applicant/applicant/document";
};
